import Lottie from 'lottie-react';

import anim from '../jsons/treatment-plan.json';

const TreatmentPlanAnimation = props => {
  return <Lottie loop={false} animationData={anim} {...props} />;
};

export default TreatmentPlanAnimation;
